"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Move = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 18,
  viewBox: "0 0 16 18",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.6 16.364V4.909H0v11.455C0 17.264.72 18 1.6 18h11.2v-1.636H1.6zM16 3.273c0-.9-.72-1.637-1.6-1.637h-2.544C11.52.687 10.64 0 9.6 0 8.56 0 7.68.687 7.344 1.636H4.8c-.88 0-1.6.737-1.6 1.637v9.818c0 .9.72 1.636 1.6 1.636h9.6c.88 0 1.6-.736 1.6-1.636V3.273zm-7.2-.818c0-.45.36-.819.8-.819.44 0 .8.369.8.819 0 .45-.36.818-.8.818-.44 0-.8-.368-.8-.818zm-2.4.818v1.636h6.4V3.273h1.6v9.818H4.8V3.273h1.6zm2.933 8.182L12 9 9.333 6.546v1.473H7.2v1.963h2.133v1.473z",
  className: "fill"
}));

var _default = Move;
exports.default = _default;